import React, { useEffect } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import '../../styles/index.css';
import Slider from 'react-slick';
import SEO from '../../components/common/SEO';
import Navbar from '../../components/navbar/navbar';
import Footer from '../../components/footer/footer';
// import PopupButton from '../components/popup/popup';
import SliderItems from '../../components/slider/SliderItems';
import ScrollButton from '../../components/scrollbutton/ScrollButton';
import { pageMeta } from '../../utils/common';
import i18n from '../../i18n';
// import BounceButton from '../components/bouncebutton/BounceButton';

const IndexPage = ({ pageContext }) => {
  console.info('language', pageContext);
  const { t } = useTranslation();

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          autoplay: false,
        },
      },
    ],
  };

  useEffect(() => {
    i18n.changeLanguage(`${pageContext.language}`);
  }, []);

  return (
    <>
      <SEO
        title={pageMeta.mainTitle}
        metaDescription={pageMeta.mainDesc}
        slug="/"
      />
      <Navbar language={pageContext.language} />
      <ScrollButton />
      {/* <BounceButton /> */}
      <div className="container mx-auto grid grid-cols-1 justify-items-center my-10 lg:my-16 lg:mb-36 lg:justify-items-start lg:grid-cols-2">
        <div className="lg:mt-7 w-5/6">
          <h3 className="py-4 text-gray">{t('grow')}</h3>
          <h1 className="text-3xl lg:text-4xl tracking-normal lh-3 mb-4 text-blue">
            <span className="text-3xl font-bold lg:text-4xl">Komunal : </span>
            {t('homeTitle')}
          </h1>
          <p className="text-base text-gray mb-5">
            {t('homeSubTitle')}
          </p>
          <a href="https://www.youtube.com/watch?v=OncJhTpPUDY" target="_blank" rel="noreferrer" className="primary-button">
            <p className="text-white">{t('watchVideo')}</p>
            <StaticImage
              src="../../images/play.png"
              alt="watch-video"
              placeholder="none"
              className="ml-2 w-6"
            />
          </a>
        </div>
        <div className="px-7 hidden lg:block lg:px-0 lg:absolute lg:right-0">
          <StaticImage
            src="../../images/komunal-indonesia.jpg"
            alt="digital-innovation"
            objectFit="contain"
            className="digital-img mt-8 lg:mt-0"
            placeholder="none"
          />
          <p className="absolute -mt-12 bg-white mx-auto left-1/2 w-36 p-1 rounded-xl text-center">Komunal Team</p>
        </div>
        <div className="px-7 block lg:hidden">
          <StaticImage
            src="../../images/komunal-indonesia-mobile.png"
            alt="komunal-indonesia"
            objectFit="contain"
            placeholder="none"
            className="digital-img mt-8"
          />
          <p className="relative -mt-9 rounded-xl text-center bg-white w-32 mx-auto text-xs px-2 py-1 self-center">
            Komunal Team
          </p>
        </div>
      </div>
      {/* <PopupButton /> */}
      <SliderItems />
      <div className="container mx-auto grid grid-cols-1 justify-items-center my-24 lg:grid-cols-2">
        <div className="w-72 lg:w-5/6">
          <StaticImage
            src="../../images/bod-1.png"
            alt="ceo-picture"
            objectFit="contain"
            placeholder="none"
            className="lg:w-96"
          />
        </div>
        <div className="container mx-auto grid px-5 mr-0 lg:-ml-32 lg:mr-20 self-center">
          <h1 className="text-center text-3xl pt-5 font-bold text-blue lg:text-left lg:pt-0">{t('ceoLetter')}</h1>
          <p className="text-base text-gray py-6 text-center lg:text-justify">
            “<span className="font-bold">Komunal </span>
            {t('ceoLetter_1')}
          </p>
          <p className="text-base text-gray text-center lg:text-justify">
            {t('ceoLetter_2')}
          </p>
          <div className="flex mx-auto lg:mx-0 lg:justify-between">
            <p className="text-base text-gray mt-8 text-center lg:text-justify">
              <span className="font-bold">Hendry Lieviant</span>
              <br />
              <span className="italic">{t('ceoKomunal')}</span>
            </p>
            <StaticImage
              src="../../images/quote.svg"
              alt="quotes"
              objectFit="contain"
              placeholder="none"
              className="mt-5 pl-6 -mr-16 lg:mr-0 lg:pl-0"
            />
          </div>
        </div>
      </div>
      <div className="impact-bg h-auto w-full relative">
        <div className="container mx-auto grid py-20 lg:pb-36 lg:grid-cols-2">
          <div className="impact-image flex flex-col-reverse px-5 lg:flex-col lg:px-0">
            <div className="flex flex-col-reverse lg:grid lg:absolute lg:left-0 ">
              <h1 className="text-3xl font-bold text-blue pt-5 lg:py-4 tracking-wide lg:ml-20 lg:w-7/12">
                {t('komunalImpact')}
              </h1>
              <div className="hidden lg:block">
                <StaticImage
                  src="../../images/impact-img-new.png"
                  alt="impact-image"
                  objectFit="contain"
                  placeholder="none"
                  className="impact-img lg:mt-10"
                />
              </div>
              <div className="block lg:hidden">
                <StaticImage
                  src="../../images/impact-image.jpg"
                  alt="impact-img"
                  objectFit="contain"
                  placeholder="none"
                  className="rounded-2xl"
                />
              </div>
            </div>
          </div>
          <div className="komunal-support px-6 lg:px-8">
            <div className="py-5">
              <h1 className="text-xl text-blue font-extralight">
                Komunal Supports
              </h1>
              <div className="flex gap-x-4">
                <div className="py-3 w-full mx-auto">
                  <h1 className="number-growth text-3xl lg:text-5xl font-bold">376+</h1>
                  <p className="text-gray text-sm lg:text-base">BPR (Rural Bank)</p>
                </div>
                <div className="py-3 w-full mx-auto">
                  <h1 className="number-growth text-3xl lg:text-5xl font-bold">24+</h1>
                  <p className="text-gray text-sm lg:text-base">Provinces</p>
                </div>
                <div className="py-3 w-full mx-auto">
                  <h1 className="number-growth text-3xl lg:text-5xl font-bold">71+</h1>
                  <p className="text-gray text-sm lg:text-base">Cities</p>
                </div>
              </div>
            </div>
            <div className="py-5">
              <h1 className="text-xl text-blue font-extralight">
                {t('providingAccess')}
              </h1>
              <div className="flex gap-x-4">
                <div className="py-3 w-full mx-auto">
                  <h1 className="number-growth text-3xl lg:text-5xl font-bold">11,410+</h1>
                  <p className="text-gray text-sm lg:text-base">Rural MSME's</p>
                </div>
                <div className="py-3 w-full lg:mx-auto">
                  <h1 className="number-growth text-3xl lg:text-5xl font-bold">98%</h1>
                  <p className="text-gray text-sm lg:text-base">Micro Enterprise</p>
                </div>
                <div className="py-3 w-full mx-auto">
                  <h1 className="number-growth text-3xl lg:text-5xl font-bold">30%</h1>
                  <p className="text-gray text-sm lg:text-base">Women-Owned MSME's</p>
                </div>
              </div>
            </div>
            <div className="py-5">
              <h1 className="text-xl text-blue font-extralight">
                resulting up to
              </h1>
              <div className="flex justify-between pr-32">
                <div className="py-3">
                  <h1 className="number-growth text-3xl lg:text-5xl font-bold">25%</h1>
                  <p className="text-gray">Increased Revenue</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto my-10 lg:my-20">
        <h1 className="text-4xl font-bold text-blue text-center">{t('komunalProduct')}</h1>
        <div className="block lg:flex justify-center lg:p-7">
          <div className="flex flex-col-reverse lg:flex-row lg:flex">
            <div className="box-products py-8 mb-8 lg:mb-0 h-auto p-7 rounded-lg lg:my-9 lg:pl-9">
              <StaticImage
                src="../../images/p2p-logo.png"
                alt="p2p-logo"
                objectFit="contain"
                placeholder="none"
                className="w-40"
              />
              <h2 className="text-3xl font-bold text-blue py-4 lg:w-5/6">
                {t('p2pHeadTitle')}
              </h2>
              <p className="text-gray lg:w-5/6">
                {t('p2pSubTitle')}
              </p>
              <a href="https://komunal.co.id/" target="_blank" rel="noreferrer" className="text-white primary-button mt-5">
                {t('learnMore')}
                <StaticImage
                  src="../../images/arrow-right.png"
                  className="ml-2 w-5"
                  placeholder="none"
                  alt="arrow-right"
                />
              </a>
              <div className="flex my-5">
                <StaticImage
                  src="../../images/ojk-logo.png"
                  alt="ojk-img"
                  objectFit="contain"
                  placeholder="none"
                  className="w-28"
                />
                <div className="pl-7">
                  <p className="text-gray font-bold">
                    Terdaftar dan diawasi OJK :
                  </p>
                  <p className="text-gray">OJK NO. KEP-51/D.05/2021</p>
                </div>
              </div>
            </div>
            <StaticImage
              src="../../images/p2p-img.png"
              alt="depositobpr-img"
              objectFit="contain"
              placeholder="none"
              className="product-img w-56 mx-auto mt-10 lg:mt-0 lg:w-96 lg:-ml-32"
            />
          </div>
        </div>
        <div className="block lg:flex justify-center lg:p-7">
          <div className="flex flex-col lg:flex lg:flex-row">
            <StaticImage
              src="../../images/depositobpr-img.png"
              alt="depositobpr-img"
              objectFit="contain"
              placeholder="none"
              className="product-img w-56 mx-auto mt-10 lg:mt-0 lg:w-96 lg:-mr-32"
            />
            <div className="box-products h-auto p-6 mb-8 rounded-lg lg:mb-0 lg:my-9 lg:py-8 lg:pl-48 lg:pr-9">
              <StaticImage
                src="../../images/deposito-logo.png"
                alt="bpr-logo"
                objectFit="contain"
                placeholder="none"
                className="w-40"
              />
              <h2 className="text-3xl font-bold text-blue py-4">
                {t('bprHeadTitle')}
              </h2>
              <p className="text-gray">
                {t('bprSubTitle')}
              </p>
              <a href="https://depositobpr.id/" target="_blank" rel="noreferrer" className="text-white primary-button mt-3">
                {t('learnMore')}
                <StaticImage
                  src="../../images/arrow-right.png"
                  className="ml-2 w-5"
                  placeholder="none"
                  alt="learn-more"
                />
              </a>
              <div className="flex my-5">
                <StaticImage
                  src="../../images/ojk-logo.png"
                  alt="ojk-img"
                  objectFit="contain"
                  placeholder="none"
                  className="w-28"
                />
                <div className="pl-7">
                  <p className="text-gray font-bold">
                    Terdaftar dan diawasi OJK :
                  </p>
                  <p className="text-gray">OJK NO. S-178/MS.72/2021</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-gray">
        <div className="container mx-auto py-10 lg:py-20">
          <h1 className="text-3xl text-blue font-bold text-center lg:text-4xl">{t('komunalCommunity')}</h1>
          <div className="grid my-8 lg:grid-cols-2">
            <div className="m-auto">
              <StaticImage
                src="../../images/community-new.png"
                alt="community-img"
                objectFit="contain"
                placeholder="none"
                class="img-width-mobile lg:w-11/12 px-4"
              />
            </div>
            <div className="px-7 my-4 lg:self-center lg:px-0 lg:my-0">
              <h4 className="text-base font-medium tracking-wide text-gray">Komunal Young Force</h4>
              <h3 className="text-xl text-deep-blue font-bold py-3">
                {t('communityBased')}
              </h3>
              <p className="text-gray tracking-wider lg:tracking-normal lg:w-5/6">
                {t('ambassadorSubTitle')}
              </p>
              <div className="flex justify-between my-3 lg:w-5/12">
                <div className="community-badge">Learn</div>
                <div className="community-badge">Grow</div>
                <div className="community-badge">Inspire</div>
              </div>
              <a href="/en/youngforce" className="text-white primary-button my-4">
                {t('learnMore2')}
                <StaticImage
                  src="../../images/arrow-right.png"
                  alt="arrow-img"
                  placeholder="none"
                  className="ml-2 w-5"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto my-5 lg:my-20">
        <h1 className="text-4xl font-bold text-center text-blue">Affiliate Business</h1>
        <div className="px-8 mt-10 flex flex-col-reverse lg:grid lg:grid-cols-2">
          <div className="self-center pt-8 m-auto lg:pt-0">
            <h4 className="text-base text-gray font-medium">PT. BPR KIRANA INDONESIA</h4>
            <h3 className="text-xl font-bold text-blue py-2 lg: w-5/6">
              {t('pdaTitle')}
            </h3>
            <a href="https://bankpda.co.id/" target="_blank" rel="noreferrer" className="text-white primary-button my-4">
              <div className="text-white">
                {t('learnMore')}
              </div>
              <StaticImage
                src="../../images/arrow-right.png"
                alt="arrow-img"
                placeholder="none"
                className="ml-2 w-5"
              />
            </a>
          </div>
          <div>
            <StaticImage
              src="../../images/bprkirana-logo.webp"
              alt="bprkirana-logo"
              placeholder="none"
              objectFit="contain"
              className="rounded-md"
            />
          </div>
        </div>
      </div>

      <div className="container mx-auto mt-20 mb-40">
        <h1 className="text-4xl font-bold text-center text-blue mb-10">{t('coverageBy')}</h1>
        <div>
          <div className="lg:hidden">
            <Slider {...settings}>
              <div className="flex flex-col p-10">
                <div className="flex flex-row gap-10">
                  <StaticImage
                    src="../../images/mediaPartner/Logo_Tech_in_Asia.png"
                    alt="Tech in Asia"
                    objectFit="contain"
                    className="m-auto w-1/3"
                    placeholder="none"
                  />
                  <StaticImage
                    src="../../images/mediaPartner/Logo_Kompas.png"
                    alt="Kompas"
                    objectFit="contain"
                    className="m-auto w-1/3"
                    placeholder="none"
                  />
                  <StaticImage
                    src="../../images/mediaPartner/Logo_Tempo_1.png"
                    alt="Tempo 1"
                    objectFit="contain"
                    className="m-auto w-1/3"
                    placeholder="none"
                  />
                </div>
                <div className="flex flex-row gap-10">
                  <StaticImage
                    src="../../images/mediaPartner/Logo_CNBC.png"
                    alt="CNBC"
                    objectFit="contain"
                    className="m-auto w-1/3"
                    placeholder="none"
                  />
                  <StaticImage
                    src="../../images/mediaPartner/Logo_Jawa_Pos.png"
                    alt="Jawa Pos"
                    objectFit="contain"
                    className="m-auto w-1/3"
                    placeholder="none"
                  />
                  <StaticImage
                    src="../../images/mediaPartner/Logo_Tribun_News.png"
                    alt="Tribun News"
                    objectFit="contain"
                    className="m-auto w-1/3"
                    placeholder="none"
                  />
                </div>
              </div>

              <div className="flex flex-col p-10">
                <div className="flex flex-row gap-10">
                  <StaticImage
                    src="../../images/mediaPartner/Logo_Suara.png"
                    alt="Suara"
                    objectFit="contain"
                    className="py-2 mt-2 w-1/2"
                    placeholder="none"
                  />
                  <StaticImage
                    src="../../images/mediaPartner/Logo_Merdeka.png"
                    alt="Merdeka"
                    objectFit="contain"
                    className="py-2 mt-2 w-1/2"
                    placeholder="none"
                  />
                  <StaticImage
                    src="../../images/mediaPartner/Logo_Liputan_7.png"
                    alt="Liputan 7"
                    objectFit="contain"
                    className="py-2 mt-2 w-1/2"
                    placeholder="none"
                  />
                </div>
                <div className="flex flex-row gap-10">
                  <StaticImage
                    src="../../images/mediaPartner/Logo_SindoNews.png"
                    alt="SindoNews"
                    objectFit="contain"
                    className="py-2 mt-2 w-1/2"
                    placeholder="none"
                  />
                  <StaticImage
                    src="../../images/mediaPartner/Logo_ANTARANews.png"
                    alt="ANTARA News"
                    objectFit="contain"
                    className="py-2 mt-2 w-1/2"
                    placeholder="none"
                  />
                  <StaticImage
                    src="../../images/mediaPartner/Logo_INews.png"
                    alt="INews"
                    objectFit="contain"
                    className="py-2 mt-2 w-1/2"
                    placeholder="no1ne"
                  />
                </div>
              </div>
            </Slider>
          </div>

          <div className="lg:flex hidden flex-wrap justify-center">
            <div className="flex justify-center items-center w-1/6">
              <StaticImage
                src="../../images/mediaPartner/Logo_Tech_in_Asia.png"
                alt="Tech in Asia"
                objectFit="contain"
                className="py-2 mt-2 w-1/2"
                placeholder="none"
              />
            </div>
            <div className="flex justify-center items-center w-1/6">
              <StaticImage
                src="../../images/mediaPartner/Logo_Kompas.png"
                alt="Kompas"
                objectFit="contain"
                className="py-2 mt-2 w-1/2"
                placeholder="none"
              />
            </div>
            <div className="flex justify-center items-center w-1/6">
              <StaticImage
                src="../../images/mediaPartner/Logo_Tempo_1.png"
                alt="Tempo 1"
                objectFit="contain"
                className="py-2 mt-2 w-1/2"
                placeholder="none"
              />
            </div>
            <div className="flex justify-center items-center w-1/6">
              <StaticImage
                src="../../images/mediaPartner/Logo_CNBC.png"
                alt="CNBC"
                objectFit="contain"
                className="py-2 mt-2 w-1/2"
                placeholder="none"
              />
            </div>
            <div className="flex justify-center items-center w-1/6">
              <StaticImage
                src="../../images/mediaPartner/Logo_Jawa_Pos.png"
                alt="Jawa Pos"
                objectFit="contain"
                className="py-2 mt-2 w-1/2"
                placeholder="none"
              />
            </div>
            <div className="flex justify-center items-center w-1/6">
              <StaticImage
                src="../../images/mediaPartner/Logo_Tribun_News.png"
                alt="Tribun News"
                objectFit="contain"
                className="py-2 mt-2 w-1/2"
                placeholder="none"
              />
            </div>
            <div className="flex justify-center items-center w-1/6">
              <StaticImage
                src="../../images/mediaPartner/Logo_Suara.png"
                alt="Suara"
                objectFit="contain"
                className="py-2 mt-2 w-1/2"
                placeholder="none"
              />
            </div>
            <div className="flex justify-center items-center w-1/6">
              <StaticImage
                src="../../images/mediaPartner/Logo_Merdeka.png"
                alt="Merdeka"
                objectFit="contain"
                className="py-2 mt-2 w-1/2"
                placeholder="none"
              />
            </div>
            <div className="flex justify-center items-center w-1/6">
              <StaticImage
                src="../../images/mediaPartner/Logo_Liputan_7.png"
                alt="Liputan 7"
                objectFit="contain"
                className="py-2 mt-2 w-1/2"
                placeholder="none"
              />
            </div>
            <div className="flex justify-center items-center w-1/6">
              <StaticImage
                src="../../images/mediaPartner/Logo_SindoNews.png"
                alt="SindoNews"
                objectFit="contain"
                className="py-2 mt-2 w-1/2"
                placeholder="none"
              />
            </div>
            <div className="flex justify-center items-center w-1/6">
              <StaticImage
                src="../../images/mediaPartner/Logo_ANTARANews.png"
                alt="ANTARA News"
                objectFit="contain"
                className="py-2 mt-2 w-1/2"
                placeholder="none"
              />
            </div>
            <div className="flex justify-center items-center w-1/6">
              <StaticImage
                src="../../images/mediaPartner/Logo_INews.png"
                alt="INews"
                objectFit="contain"
                className="py-2 mt-2 w-1/2"
                placeholder="no1ne"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gray my-10 lg:my-20">
        <div className="container mx-auto py-10 lg:py-20">
          <h1 className="text-4xl font-bold text-center text-blue">{t('komunalOnMedia')}</h1>
          <div className="grid grid-cols-1 justify-items-center py-12 lg:grid-cols-3">
            <div className="py-5 px-7 lg:px-0 lg:py-0 lg:w-5/6">
              <StaticImage
                src="../../images/media-1.jpg"
                alt="media-1"
                objectFit="contain"
                placeholder="none"
                className="rounded-2xl"
              />
              <div className="w-72">
                <p className="text-gray-500 text-sm py-3">January 17, 2023</p>
                <a
                  href="https://techcrunch.com/2023/01/17/komunal/"
                  className="font-bold text-base"
                  target="_blank"
                  rel="noreferrer"
                >
                  Komunal raises $8.5M to digitize Indonesia’s rural banks
                </a>
                <br />
                <a href="https://techcrunch.com/" className="text-blue-500 text-xs" target="_blank" rel="noreferrer">
                  techcrunch.com
                </a>
              </div>
            </div>
            <div className="py-5 px-7 lg:px-0 lg:py-0 lg:w-5/6">
              <StaticImage
                src="../../images/media-2.jpg"
                alt="media-2"
                objectFit="contain"
                placeholder="none"
                className="rounded-2xl w-full"
              />
              <div className="w-80">
                <p className="text-gray-500 text-sm py-3">September 6, 2022</p>
                <a
                  href="https://aptika.kominfo.go.id/2022/09/startup-terbaik-din-g20-siap-go-internasional/"
                  className="font-bold text-base"
                  target="_blank"
                  rel="noreferrer"
                >
                  Startup Terbaik DIN G20 Siap Go Internasional
                </a>
                <br />
                <a href="https://aptika.kominfo.go.id" className="text-blue-500 text-xs" target="_blank" rel="noreferrer">
                  aptika.kominfo.go.id
                </a>
              </div>
            </div>
            <div className="py-5 px-7 lg:px-0 lg:py-0 lg:w-5/6">
              <StaticImage
                src="../../images/media-3.jpg"
                alt="media-3"
                objectFit="contain"
                placeholder="none"
                className="rounded-2xl"
              />
              <div className="w-72">
                <p className="text-gray-500 text-sm py-3">August 16, 2022</p>
                <a
                  href="https://dailysocial.id/post/lanjutkan-upaya-digitalisasi-bpr-komunal-rilis-e-deposito"
                  className="font-bold text-base"
                  target="_blank"
                  rel="noreferrer"
                >
                  Lanjutkan Upaya Digitalisasi BPR, Komunal Rilis "E-Deposito"
                </a>
                <br />
                <a href="https://dailysocial.id" className="text-blue-500 text-xs" target="_blank" rel="noreferrer">
                  dailysocial.id
                </a>
              </div>
            </div>
          </div>
          <a href="https://depositobpr.id/blog" target="_blank" rel="noreferrer" className="text-white primary-button mx-auto">
            {t('seeArticle')}
            <StaticImage
              src="../../images/arrow-right.png"
              alt="arrow-right"
              placeholder="none"
              className="ml-2 w-5"
            />
          </a>
        </div>
      </div>
      <Footer />
    </>
  );
};

IndexPage.propTypes = {
  pageContext: PropTypes.object.isRequired,
};

export default IndexPage;
